import React from 'react';
import { makeStyles } from '@mui/styles';
// import { Policy } from './components';
import { Section } from 'components/organisms';
import { useNavigate, useParams } from 'react-router-dom';
import { policyMap } from './data';
import { Policy } from './components';
import { Typography } from '@mui/material';

const useStyles = makeStyles(theme => ({
    pagePaddingTop: {
        paddingTop: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            paddingTop: theme.spacing(5),
        },
    },
    // sectionAlternate: {
    //   background: 'transparent',
    //   backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.dark} 0%)`,
    // },
}));

const Policies = ({ }) => {
    const { policyName } = useParams();
    const classes = useStyles();

    const navigate = useNavigate();

    const policyData = policyMap[policyName];

    if(!policyData) {        
        navigate("/not-found-cover");
        return;
    }

    return (
        <div>
            <Section className={classes.pagePaddingTop}>
                <Policy {...policyData} />
            </Section>
        </div>
    );
};

export default Policies;